import { AbstractIntProperty } from './AbstractIntProperty'

export class LanguageId extends AbstractIntProperty {
  KEY: string = 'languageId'
}
